import { ACCOUNT_INITIALISE, LOGIN, LOGOUT, PERIMETRE_MODE } from './actions'

const accountReducer = (state, action) => {
  switch (action.type) {
    case ACCOUNT_INITIALISE: {
      const { isLoggedIn, user, menu, admin, entity, scope, client_access } = action.payload
      return {
        ...state,
        isLoggedIn,
        isOtp: true,
        isInitialised: true,
        user,
        menu,
        admin,
        entity,
        scope,
        client_access
      }
    }
    case LOGIN: {
      const { user, menu, admin, entity, scope, isInitialised, isOtp,client_access} = action.payload
      return {
        ...state,
        isLoggedIn: true,
        menu,
        admin,
        user,
        entity,
        scope,
        isInitialised,
        isOtp,client_access
      }
    }
    case LOGOUT: {
      return {
        ...state,
        isLoggedIn: false,
        user: null
      }
    }
    case PERIMETRE_MODE: {
      const { user, menu, admin, entity, scope } = action.payload
      return {
        ...state,
        isLoggedIn: true,
        menu,
        admin,
        user,
        entity,
        scope
      }
    }
    default: {
      return { ...state }
    }
  }
}

export default accountReducer
